<template>
    <div class="ContactUs">
        <menuBox :step="4"></menuBox>
        <div class="contact-box">
            <div class="title">Contact Us</div>
            <p class="sbtitle">Looking forward to working with you to create a better future</p>
        </div>
        <div class="form-box">
            <div class="title">Make an appointment for consultation</div>
            <p class="sbtitle">No matter you have any questions, needs or cooperation intentions, we are willing to listen and provide you with professional solutions.</p>
            <div class="info-box">
                <div class="item">
                    <div>Address</div>
                    <p>Dubai Silicon Oasis, DDP, Building A1,Dubai, United Arab Emirates</p>
                </div>
                <div class="item">
                    <div>Email</div>
                    <p>wade@db-inferno.com</p>
                </div>
            </div>
        </div>

        <div class="input-box">
            <div class="input-1">
                <input type="text" v-model="name" placeholder="Name" class="input-text">
                <input type="text" v-model="tele" placeholder="Telephone" class="input-text">
            </div>
            <div class="input-1">
                <input type="text" v-model="email" placeholder="Email" class="input-text">
                <input type="text" v-model="subject" placeholder="Subject" class="input-text">
            </div>
            <textarea name="" id="" v-model="msg" cols="30" rows="10" placeholder="Message …" class="textarea-box"></textarea>
            <div class="msg-btn" @click="SubmitOk">Send Message</div>
        </div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            name: '',
            tele: '',
            email: '',
            subject: '',
            msg: ''
        }
    },
    mounted() {

    },
    methods: {
        SubmitOk() {
            if (!this.name) {
                return alert('please enter your Name')
            } else if (!this.tele) {
                return alert('please enter your Telephone')
            } else if (!this.email) {
                return alert('please enter your Email')
            } else if (!this.subject) {
                return alert('please enter your Subject')
            }
            alert('Submitted successfully')
        }
    }
}
</script>
<style lang="less" scoped>
.title {
    font-weight: bold;
    font-size: 40px;
    color: #FFFFFF;
    text-align: center;
}

.sbtitle {
    font-size: 20px;
    color: #FFFFFF;
    margin-top: 22px;
    text-align: center;
}

.contact-box {
    height: 375px;
    background: url(../assets/bg-1.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form-box {
    padding: 80px 360px;

    .title {
        color: #333;
    }

    .sbtitle {
        color: #999;
    }

    .info-box {
        margin-top: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item {
            width: 320px;
            padding: 48px;
            box-shadow: 0px 12px 24px 0px rgba(215, 215, 215, 0.5);

            div {
                font-weight: 900;
                font-size: 20px;
                color: #333333;
            }

            p {
                font-weight: 600;
                font-size: 16px;
                color: #999999;
                margin-top: 14px;
            }
        }
    }
}

.input-box {
    padding: 0px 360px 80px 360px;


    .input-1 {
        display: flex;
        text-align: center;
        justify-content: space-between;
        margin-top: 16px;

        .input-text {
            width: 535px;
            height: 48px;
            background: #EBEFF3;
            padding: 5px 20px;
        }
    }

    .textarea-box {
        width: 1145px;
        height: 140px;
        background: #EBEFF3;
        padding: 20px;
        margin-top: 16px;
    }

    .msg-btn {
        margin-top: 24px;
        height: 64px;
        background: #FAAD14;
        line-height: 64px;
        font-weight: 600;
        font-size: 20px;
        color: #FFFFFF;
        text-align: center;
    }
}
</style>
